export enum DashboardTheme {
  GUEST = "GUEST",
  SLOTTING = "SLOTTING",
  EMAIL = "EMAIL",
  ACTIVITY = "ACTIVITY",
  EVENT_HERO = "EVENT_HERO",
  KPI_METRIC = "KPI_METRIC",
  LINKS = "LINKS",
  CHECKIN = "CHECKIN",
  SEATING = "SEATING",
  AUTOMATION = "AUTOMATION",
  WEBSITE = "WEBSITE",
  /** One event-goal KPI (preSelector = goal-KPI id): value vs target/threshold. */
  GOAL_KPI = "GOAL_KPI",
  /** AI goal-fit snapshot from the latest cohort analysis (score + top gap). */
  GOAL_FIT = "GOAL_FIT",
  /** Check-ins/check-outs bucketed over the event (preSelector = "hour"|"day"). */
  CHECKIN_TIMESERIES = "CHECKIN_TIMESERIES",
}
